// @flow
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import makeIndicatorInstance from './selector';


type Props = {
  subId: number,
};

const enhance = compose(
  withTranslation('subs'),

  connect(
    () => {
      const indicatorSelector = makeIndicatorInstance();
      return (state, props: Props) => ({
        ...indicatorSelector(state, props),
      });
    }
  )
);

export default enhance;
